import { Phone } from '@marageti/z4-sdk/lib/standards';
import { Validate } from '@marageti/z4-lib';

export const validatePhone = (phone: Phone) => {
  if (!phone.number) return true;
  return Validate.phone(`${phone.prefix}${phone.number}`);
};

export const validateEmail = (email: string) => {
  if (!email) return true;
  return Validate.email(email);
};

export const validateUrl = (url: string) => {
  if (!url) return true;
  return Validate.url(url);
};

export const phoneToE164 = (phone?: Phone): string => {
  if (!phone?.number) return '';
  let { prefix = '' } = phone;
  if (prefix && !prefix.startsWith('+')) prefix = `+${prefix}`;
  return `${prefix}${phone.number}`.replace(/\s/g, '');
};
